class PersonalizeProduct extends HTMLElement {
  constructor() {
    super();
    this.textFront = new Map();
    this.textBack = new Map();
    this.isFrontImageSelected = true;
    const context = this;
    const fontEnabled = this.querySelector('.personalize-font') ? true : false;

    this.querySelector('.personalize-button').addEventListener('click', function () { 
      this.classList.add('hidden');
      context.createCanvas();
    });

    Array.from(this.querySelectorAll(`[id^="Personalize-name-front-"]`)).forEach((inputs) => {
      inputs.addEventListener('keyup', (event) => this.onFrontTextChange(event, context));
    })

    Array.from(this.querySelectorAll(`[id^="Personalize-name-back-"]`)).forEach((inputs) => {
      inputs.addEventListener('keyup', (event) => this.onBackTextChange(event, context));
    })

    if (fontEnabled) {
      this.fontFamily = this.querySelector('.personalize-font input').value;

      this.initFont();
        
      Array.from(this.querySelectorAll('.personalize-font label')).forEach((options) => {
        options.addEventListener('click', (event) => this.onFontChange(event, context));
      })
    }

    window.addEventListener('resize', () => {
      this.drawCanvasContent();
    });

    const checkButtons = setInterval(() => {
      const buttonFront = document.querySelector('.personalized_front');
      const buttonBack = document.querySelector('.personalized_back');
      if (!buttonFront || !buttonBack) return;
      clearInterval(checkButtons);
      buttonFront.addEventListener('click', () => this.onButtonFrontSelected(buttonFront, buttonBack, context));
      buttonBack.addEventListener('click', () => this.onButtonBackSelected(buttonFront, buttonBack, context));
    }, 100);
  }

  onFrontTextChange(event, context) {
    const dataset = event.target.dataset;
    const productForm = document.querySelector(`#product-form-${context.dataset.section}`);
    const inputFront = context.getInputElementFront(dataset.id);
    const inputFrontValue = context.dataset.uppercase == 'true' ? inputFront.value.toUpperCase() : inputFront.value;

    var inputTextFront = document.querySelector(`input[name="properties[${dataset.propertyName}]"]`);
    if (inputFrontValue) {
      if (!inputTextFront) {
        inputTextFront = document.createElement('input');
        inputTextFront.setAttribute('type', 'hidden');
        inputTextFront.setAttribute('name', `properties[${dataset.propertyName}]`);
        inputTextFront.setAttribute('value', inputFrontValue);
        productForm.appendChild(inputTextFront);
      } else {
        inputTextFront.value = inputFrontValue;
      }
    }

    this.textFront.set(dataset.id, inputFrontValue);
    this.querySelector(`.characters_used_${dataset.id}`).innerText = inputFrontValue.trim().length;
    this.drawCanvasContent();
  }

  onBackTextChange(event, context) {
    const dataset = event.target.dataset;
    const productForm = document.querySelector(`#product-form-${context.dataset.section}`);
    const inputBack = context.getInputElementBack(dataset.id);
    const inputBackValue = context.dataset.uppercase == 'true' ? inputBack.value.toUpperCase() : inputBack.value;

    var inputTextBack = document.querySelector(`input[name="properties[${dataset.propertyName}]"]`);
    if (inputBackValue) {
      if (!inputTextBack) {
        inputTextBack = document.createElement('input');
        inputTextBack.setAttribute('type', 'hidden');
        inputTextBack.setAttribute('name', `properties[${dataset.propertyName}]`);
        inputTextBack.setAttribute('value', inputBackValue);
        productForm.appendChild(inputTextBack);
      } else {
        inputTextBack.value = inputBackValue;
      }
    }

    this.textBack.set(dataset.id, inputBackValue);
    this.querySelector(`.characters_used_${dataset.id}`).innerText = inputBackValue.trim().length;
    this.drawCanvasContent();
  }

  initFont() {
    const productForm = document.querySelector(`#product-form-${this.dataset.section}`);
    var inputFont = productForm.querySelector('input[name="properties[Fonte personalizada]"]');
    const fontSelected = document.querySelector('.personalize-font input:checked').value;
    if (!inputFont) {
      inputFont = document.createElement('input');
      inputFont.setAttribute('type', 'hidden');
      inputFont.setAttribute('name', 'properties[Fonte personalizada]');
      inputFont.setAttribute('value', fontSelected);
      productForm.appendChild(inputFont);
    } else {
      inputFont.value = fontSelected;
    }
  }
  
  onFontChange(event, context) {
    const fontFamily = event.target.closest('.item').querySelector('input').value;
    context.getInputElementFront().forEach(input => input.style.fontFamily = fontFamily);
    context.getInputElementBack().forEach(input => input.style.fontFamily = fontFamily);

    const productForm = document.querySelector(`#product-form-${this.dataset.section}`);
    productForm.querySelector('input[name="properties[Fonte personalizada]"]').value = fontFamily;
    
    this.fontFamily = fontFamily;
    this.drawCanvasContent();
  }

  onButtonFrontSelected(buttonFront, buttonBack, context) {
    console.log("@@@!!!");
    buttonBack.classList.remove('active');
    buttonFront.classList.add('active');
    context.getInputElementFront().forEach(input => input.classList.remove('hidden'));
    context.getInputElementBack().forEach(input => input.classList.add('hidden'));
    context.isFrontImageSelected = true;
    this.drawCanvasContent();
    for (let i = 1; i <= 4; i++) {
      const charactersUsed = context.querySelector(`.characters_used_${i}`);
      const inputEl = context.getInputElementFront(i);
      if (!charactersUsed || !inputEl) continue;
      charactersUsed.innerText = inputEl.value.trim().length;
    }
  }

  onButtonBackSelected(buttonFront, buttonBack, context) {
    console.log("@@@");
    buttonFront.classList.remove('active');
    buttonBack.classList.add('active');
    context.getInputElementFront().forEach(input => input.classList.add('hidden'));
    context.getInputElementBack().forEach(input => input.classList.remove('hidden'));
    context.isFrontImageSelected = false;
    this.drawCanvasContent();
    for (let i = 1; i <= 4; i++) {
      const charactersUsed = context.querySelector(`.characters_used_${i}`);
      const inputEl = context.getInputElementBack(i);
      if (!charactersUsed || !inputEl) continue;
      charactersUsed.innerText = inputEl.value.trim().length;
    }
  }

  getSlide() {
    const mainSlide = document.querySelector('media-gallery slider-component');
    const li = mainSlide ? mainSlide.querySelector('ul li:nth-child(2)') : null;
    return li ? li.querySelector('.product-media-container') : null;
  }

  createCanvas() {
    const container = this.getSlide();
    if (!container) return;

    container.style.position = 'relative';

    var newCanvas = document.createElement('canvas');
    newCanvas.setAttribute('id', 'PreviewPersonalize');
    newCanvas.style.pointerEvents = 'none';
    container.appendChild(newCanvas);

    this.initialWidth = container.clientWidth;
    this.initialHeight = container.clientHeight;

    this.drawCanvasContent();
  }

  drawCanvasContent() {
    const canvas = document.getElementById('PreviewPersonalize');
    const fieldsData = JSON.parse(document.querySelector('#PersonalizeJSON').textContent);
    const slide = this.getSlide();

    if (!(canvas && slide && fieldsData.some(field => field.axis_x && field.axis_y))) return;

    canvas.setAttribute('width', slide.clientWidth);
    canvas.setAttribute('height', slide.clientHeight);

    const mainSlide = document.querySelector('media-gallery slider-component');
    if (mainSlide.currentPage !== 2) mainSlide.slider.scrollTo(slide.clientWidth, 0);

    const initialFontSize = this.dataset.canvaFontSize;
    let fontSize = initialFontSize;
    if (slide.clientWidth !== this.initialWidth) {
      fontSize = (slide.clientWidth * initialFontSize) / this.initialWidth;
    }
    const ctx = canvas.getContext('2d');
    ctx.font = `${fontSize}px ${this.fontFamily}`;

    ctx.fillStyle = '#6B5629';
    ctx.textAlign = 'center';
    fieldsData.forEach((field) => {
      const initialX = (field.axis_x * this.initialWidth) / 477.5;
      const initialY = (field.axis_y * this.initialHeight) / 596.88;
      const x = (slide.clientWidth * initialX) / this.initialWidth;
      const y = (slide.clientHeight * initialY) / this.initialHeight;
      const text = this.isFrontImageSelected ? this.textFront.get(field.id) : this.textBack.get(field.id);
      ctx.fillText(text || '', x, y);
    })
  }

  getInputElementFront(id) {
    return id ? document.querySelector(`[id^="Personalize-name-front-${id}"]`) : Array.from(document.querySelectorAll(`[id^="Personalize-name-front-"]`));
  }

  getInputElementBack(id) {
    return id ? document.querySelector(`[id^="Personalize-name-back-${id}"]`) : Array.from(document.querySelectorAll(`[id^="Personalize-name-back-"]`));
  }
}

customElements.define('personalize-product', PersonalizeProduct);